<template>
    <span>
        <v-flex xs-12 class="row">
        <v-card max-width="200" class="m-3" v-for="pryect in otherProyecs" v-if="pryect.id != '2'">
            <v-img
                    class="white--text"
                    max-height="150"
                    max-width="400"
                    :src="pryect.inform_data.image_url"
            >
                <v-container fill-height fluid>
                    <v-layout fill-height>
                        <v-flex xs12 align-end flexbox>

                        </v-flex>
                    </v-layout>
                </v-container>
            </v-img>
            <v-card-title>
                <div>
                    <span class="font-weight-medium text-uppercase">{{pryect.name}}</span><br>
                </div>
            </v-card-title>
            <v-card-actions>


            </v-card-actions>
        </v-card>
    </v-flex>
    </span>
</template>
<script>
    import {mapState} from 'vuex'
    import axios from 'axios'
    export default {
        name: 'otherProyects',
        components: {

        },
        created(){
            this.getOtherProyects();
        },
        data(){
            return {
                otherProyecs:[],
            }
        },
        computed: {
            ...mapState,


        },
        methods:{
            getOtherProyects:function () {
                var url = '/api/v1/getAllProyects';

                axios.get(url, axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('a_t')).then(response => {
                    this.otherProyecs = response.data;
                });
            }
        }

    }
</script>